// extracted by css-extract-rspack-plugin
export default {"rowContent":"yNhiPgvy"};